module.exports = __webpack_public_path__ + "static/headzup-meta-image-2-e2da63f864e231bbb14031dacf528e04.jpg";